import { render } from "./TituloFinanceiroTotalizadores.vue?vue&type=template&id=9b7da92a&scoped=true&ts=true"
import script from "./TituloFinanceiroTotalizadores.vue?vue&type=script&lang=ts"
export * from "./TituloFinanceiroTotalizadores.vue?vue&type=script&lang=ts"

import "./TituloFinanceiroTotalizadores.vue?vue&type=style&index=0&id=9b7da92a&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b7da92a"]])

export default __exports__